export const classes = {
  card: 'h-full shrink-0 w-[300px] px-4 pt-4 pb-4 min-h-0 bg-gradient-to-br from-white to-orange-300/40 via-orange-100/20 from-30% flex flex-col dark:bg-none dark:bg-white/[0.04]',
  titleWrapper: 'flex justify-between items-start px-2 mb-4',
  title: 'text-grey-8 dark:text-mauve-1 font-medium text-lg',
};
